import React from 'react';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';
import { Text } from '@paygreen/paygreen-ui';
import {
    ModalBlock,
    SimpleActionButton,
    ValidateButton,
} from '../../../../components';
import { PartnershipModalContent, PartnershipToastMessage } from '../../shared';
import { createPartnership } from '../../service';

const CardMainButton = ({ t, partnerId, partnerName, getData, isLoading }) => (
    <ModalBlock
        blockWidth="md"
        closeWithAction={getData}
        modalTitle={t('partnershipButtons.becomePartner')}
        button={
            <ValidateButton icon="HeartIcon" isDisabled={isLoading}>
                {t('partnershipButtons.becomePartner')}
            </ValidateButton>
        }
    >
        <PartnershipModalContent
            closeWithAction={getData}
            sdkPartnershipAction={() => createPartnership(partnerId)}
            buttonCancelAction={
                <SimpleActionButton icon="ArrowRoundTopLeftIcon">
                    {t('partnershipButtons.notYet')}
                </SimpleActionButton>
            }
            buttonConfirmAction={
                <ValidateButton icon="LetterIcon">
                    {t('partnershipButtons.sendRequest')}
                </ValidateButton>
            }
            toastMessage={
                <PartnershipToastMessage
                    i18nKey="form.toastSuccess.partnershipRequest"
                    partnerName={partnerName}
                />
            }
            isLoading={isLoading}
        >
            <Text textSize="sm">
                <Trans i18nKey="ShopPartnerships.allCharities.message">
                    Are you sure to send request
                    <Text htmlTag="strong" textSize="sm">
                        {{ partnerName }}
                    </Text>
                    This manipulation is irreversible
                </Trans>
            </Text>

            <Text textSize="sm" marginTop="xs">
                {t('ShopPartnerships.allCharities.ready')}
            </Text>
        </PartnershipModalContent>
    </ModalBlock>
);

CardMainButton.propTypes = {
    partnerId: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    getData: PropTypes.func.isRequired,
};

export default withTranslation('common')(CardMainButton);
